var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Ec24 = function Ec24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.715 4.246a1.032 1.032 0 0 1 1.031-1.031h12.501a1.032 1.032 0 0 1 1.032 1.031v15.506a1.03 1.03 0 0 1-1.032 1.033h-12.5a1.034 1.034 0 0 1-1.032-1.033V4.246z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.247 21h-12.5A1.249 1.249 0 0 1 4.5 19.752V4.246A1.248 1.248 0 0 1 5.746 3h12.501a1.248 1.248 0 0 1 1.247 1.246v15.506A1.25 1.25 0 0 1 18.247 21zM5.747 3.43a.818.818 0 0 0-.817.816v15.506a.818.818 0 0 0 .816.818h12.501a.818.818 0 0 0 .817-.818V4.246a.818.818 0 0 0-.817-.816h-12.5z",
    fill: "#007FC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11 7.52v1.653h.923V7.021H9.61a.501.501 0 0 0-.501.5zm0 5.71a.516.516 0 0 0 .506.526h.417v-1.684h2.88v3.974H7.525c-.714 0-1.23-.58-1.23-1.29V6.022c0-.715.518-1.292 1.23-1.292h5.386v6.678H9.11v1.824",
    fill: "#007FC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.55 18.312h.267v-.148c-.004-.165-.035-.22-.141-.22-.13 0-.127.149-.127.302v.066zm-.263.396v-.44c-.015-.395.126-.62.384-.62.37 0 .409.275.409.736v.224h-.53v.244c.005.22.061.262.14.262.096 0 .127-.102.123-.316h.263c.01.374-.096.61-.365.61-.306 0-.431-.21-.424-.702",
    fill: "#007FC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.727 16.046h-5.284l-.06-.008-.055-.007-.062-.011-.055-.015-.055-.02-.055-.019-.055-.019a1.282 1.282 0 0 1-.7-.725l-.02-.055-.015-.062-.015-.055-.015-.055-.008-.062-.008-.055v-.064l-.004-.055V6.012c0-.33.129-.649.358-.887.115-.124.255-.223.41-.29l.055-.024.055-.019.055-.015.055-.015.06-.012.058-.006.055-.008.061-.004h5.246v4.437H14.97V7.015c-.426-.068-.886.03-.912.529v-.195.201-.006 5.678-.008.05-.042c.027.501.485.6.919.528v-2.308l.012-.042h2.738v4.643",
    fill: "#D23F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.034 18.275h-.263v-.186c-.004-.092-.038-.146-.092-.146-.101 0-.101.171-.101.373v.398c-.01.327.022.388.101.403.08-.005.085-.115.092-.248v-.155h.263v.155c0 .35-.099.541-.361.541-.233 0-.365-.179-.355-.625v-.54c-.004-.473.152-.595.355-.595.266 0 .366.243.36.491v.134z",
    fill: "#D23F47"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.469 16.046a1.292 1.292 0 0 1-.85-.388 1.362 1.362 0 0 1-.275-.436l-.02-.055-.015-.062-.015-.055-.015-.055-.008-.062-.008-.055v-.064l-.005-.055v-2.687h1.658v3.974h-.447zM11.255 6.012c.033-.912.779-1.396 1.657-1.28v6.676h-1.657V6.012z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.548 17.14h-.266v2.228h.266V17.14z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.001 18.312h.263v-.148c0-.165-.03-.22-.136-.22-.135 0-.127.149-.127.302v.066zm-.262.396v-.44c-.012-.395.125-.62.384-.62.37 0 .41.275.41.736v.224H8v.244c.004.22.062.262.138.262.1 0 .125-.102.122-.316h.266c.012.374-.095.61-.365.61-.305 0-.427-.21-.423-.702",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 18.275h-.263v-.186c-.004-.092-.034-.146-.09-.146-.102 0-.102.171-.102.373v.398c0 .327.025.388.102.403.079-.005.081-.115.09-.248v-.155h.262v.155c0 .35-.094.541-.358.541-.236 0-.369-.179-.358-.625v-.54c0-.473.156-.595.358-.595.268 0 .362.243.358.491v.134zM9.937 19.07v.307c-.16.023-.377.047-.377-.265v-1.139h-.107v-.28h.103v-.462h.267v.462h.114v.28h-.114v1.044c.007.069.08.055.114.052M10.299 17.693v.296h.004a.62.62 0 0 1 .103-.236.194.194 0 0 1 .164-.091v.46c-.148-.023-.258.031-.262.28v.966h-.267v-1.675h.256",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.045 19.41c-.346.012-.408-.24-.404-.819.005-.579.004-.941.404-.941s.398.366.398.941c0 .576-.054.831-.398.82zm-.14-1.146v.556c0 .205.015.297.14.297.126 0 .134-.092.134-.297v-.556c0-.156 0-.32-.134-.32-.133 0-.14.164-.14.32z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.872 17.693v.17h.004c.06-.194.18-.213.24-.213.148 0 .27.125.263.423v1.295h-.263v-1.116c0-.165-.015-.27-.114-.279-.1-.01-.134.135-.13.31v1.085h-.262v-1.675h.262z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.854 17.49h-.268v-.35h.268v.35zm0 1.878h-.268v-1.676h.268v1.676z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.754 18.275h-.265v-.186c-.006-.092-.035-.146-.09-.146-.101 0-.101.171-.099.373v.398c-.007.327.02.388.1.403.08-.005.08-.115.089-.248v-.155h.265v.155c0 .35-.1.541-.362.541-.232 0-.37-.179-.359-.625v-.54c0-.473.158-.595.359-.595.267 0 .362.243.362.491v.134z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.662 18.663v-.18c-.064.065-.144.133-.216.213a.378.378 0 0 0-.042.202c0 .13.03.218.125.218.154 0 .127-.288.133-.453zm.286.704h-.25a.641.641 0 0 1-.015-.17c-.065.135-.145.212-.237.212-.213 0-.305-.152-.305-.502 0-.378.183-.473.392-.598a.24.24 0 0 0 .13-.28c-.011-.075-.056-.087-.122-.087-.121 0-.14.092-.14.244h-.253c0-.316.069-.537.4-.537.362 0 .381.27.381.494v.99c0 .078.006.156.02.233",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.062 18.816h.263c-.019.308.065.3.123.3.08 0 .13-.083.11-.19-.004-.095-.08-.149-.13-.197l-.14-.146a.698.698 0 0 1-.22-.53c0-.258.14-.403.391-.403.26 0 .379.194.37.55h-.264c.006-.186-.029-.259-.123-.259-.063 0-.11.042-.11.138a.25.25 0 0 0 .1.194l.219.212c.09.09.151.205.175.33.027.293-.023.594-.393.594-.136 0-.4-.083-.37-.594M17.233 19.368h-.267V17.14h.267v.725h.003c.072-.198.183-.214.237-.214.152 0 .274.125.267.422v1.296h-.267v-1.145c0-.165-.01-.27-.11-.275-.1-.005-.133.13-.13.312v1.113",
    fill: "#000"
  }));
};

Ec24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Ec24
};
export var Ec = function Ec(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Ec' icon. Please use one of the available sizes: '24'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};